module.exports = __webpack_public_path__ + "static/media/logo2.060303c3.jpg";